module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "90%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "rounded": "xl",
      "height": _vm.sideHeight
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("\n      Einstellungen - " + _vm._s(_vm.navPoints.find(function (item) { return item.value === _vm.select; }).bezeichnung) + "\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text"
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "mt-4",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "permanent": "",
      "floating": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": "",
      "nav": ""
    }
  }, _vm._l((_vm.navPoints), function(item, index) {
    return _c('v-list-item', {
      key: index,
      class: _vm.select === item.value ? 'grey lighten-3' : '',
      attrs: {
        "link": ""
      },
      on: {
        "click": function($event) {
          _vm.select = item.value
        }
      }
    }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.bezeichnung))])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "10"
    }
  }, [(_vm.select === 'nutzerverwaltung') ? _c('Nutzerverwaltung', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'allgemein') ? _c('Allgemein', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'design') ? _c('Design', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'kontakte') ? _c('Kontakte', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'gruppen') ? _c('Gruppen', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'kassen') ? _c('Kassen', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'kalender') ? _c('Kalender', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'rollen') ? _c('Rollen', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'templates') ? _c('Templates', {
    staticClass: "mt-4"
  }) : _vm._e(), _vm._v(" "), (_vm.select === 'imexport') ? _c('ImExport', {
    staticClass: "mt-4"
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fccf3452"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/einstellungen.vue
// module id = 822
// module chunks = 15